var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"solo":"","label":"Select language","items":_vm.languages,"hide-details":"","disabled":_vm.disabled},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}})}
var staticRenderFns = []

export { render, staticRenderFns }